export default __webpack_public_path__ + "static/media/regulatory--no-horn--g2.5841efbd.png";